import React from "react";
import Dialog from "@material-ui/core/Dialog";
import { DialogTitle } from "../components/DialogTitle";
import { DialogContentWithCards } from "../components/DialogContent";
import Typography from "@material-ui/core/Typography";
import Chip from "@material-ui/core/Chip";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import { TextLabel } from "../components/TextLabel";
import { Chips } from "../components/Chips";
import SimpleTable from "../components/SimpleTable";
import { PaperCard } from "../components/PaperCard";
import OrganizationName from "../containers/OrganizationName";
import MaterialTable from "material-table";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import Checkbox from '@material-ui/core/Checkbox';
import VisibilityOnIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import Tooltip from '@material-ui/core/Tooltip';
import _ from 'lodash';
import { ShowHide } from "../components/ShowHide";
import MultiInputTextField from "../components/MultiInputTextField";
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

export const DeviceGroupInfoDialog = ({
    onClose,
    onEdit,
    onDelete,
    deviceGroup: { name, registrationCode, doNotDelete, organizationRef, allApprovedAppIds, hiddenAppRefs, firstTimeUseAppRef, firstTimeUseFilePaths },
    allAppBundles,
    selectedBundleKeys,
    kioskAppTitle,
    firstTimeUseAppTitle,
    apps
}) => {
    const skinnyTableHeader = {
        paddingRight: '0px',
        width: '1px'
    }

    let approvedApps = [];
    let hiddenApps = {};

    _.map(apps, (val, key) => {
        if (allApprovedAppIds && allApprovedAppIds.indexOf(key) !== -1) {
            approvedApps.push(val);

            if (!val.showInLaunchers) {
                hiddenApps[key] = true;
            }
        }
    });

    _.forEach(hiddenAppRefs, (appRef) => {
        hiddenApps[appRef.id] = true;
    });

    let columns = [
        {
            title: '',
            sorting: false,
            headerStyle: skinnyTableHeader,
            cellStyle: { padding: '0px' },
            render: (rowData) => {
                let checked = rowData._id in hiddenApps;
                let title = checked ? "App Hidden in Mighty Launcher" : "App Visible in Mighty Launcher"
                return (
                    <span style={{ whiteSpace: 'nowrap' }}>
                        <Tooltip title={title} aria-label="App Visibility">
                            <Checkbox checked={checked}
                                icon={<VisibilityOnIcon />}
                                checkedIcon={<VisibilityOffIcon />}
                            />
                        </Tooltip>
                        <ShowHide hide={!rowData.defaultVersionClone}>
                            <Tooltip title="App Version is set to Default Version. Devices in this Device Group will update this app whenever a new Default Version of this app is set." aria-label="App Default Version">
                                <Chip label="Default Version" size="small" />
                            </Tooltip>
                        </ShowHide>
                    </span>
                )
            }
        },
        {
            title: 'Icon',
            sorting: false,
            render: (rowData) => <img src={rowData.iconUrl} alt={rowData.title} style={{ width: "50px" }} />
        },
        {
            title: 'Title',
            field: 'title'
        },
        {
            title: 'Package Name',
            field: 'packageName'
        },
        {
            title: 'App Type',
            defaultSort: 'desc',
            render: (rowData) => rowData.apkUrl ? "Managed" : "External",
            customSort: (rowDataA, rowDataB) => {
                let typeA = rowDataA.apkUrl ? "Managed" : "External";
                let typeB = rowDataB.apkUrl ? "Managed" : "External";
                return typeA.localeCompare(typeB);
            },
        },
        {
            title: 'Version Code',
            field: 'latestVersion'
        },
        {
            title: 'Version Name',
            field: 'versionName'
        }
    ]

    return (
        <Dialog maxWidth="lg" scroll="body" onClose={onClose} open>
            <DialogTitle
                onEdit={onEdit}
                onDelete={onDelete}
                darkBg
                doNotDelete={doNotDelete}
                organizationRef={organizationRef}
            >
                Device Group: {name}
            </DialogTitle>
            <DialogContentWithCards>
                <Grid container spacing={3}>
                    <Grid item xs={6}>
                        <PaperCard>
                            <TextLabel label="Name" value={name} />
                            <TextLabel label="Registration Code" value={registrationCode} />
                            <br />
                            <br />
                            <Chips
                                data={allAppBundles}
                                readonly
                                selectedValue={selectedBundleKeys}
                                title="Approved App Bundles"
                            />
                            <TextLabel label="Kiosk App" value={kioskAppTitle} />
                            <OrganizationName organizationRef={organizationRef} />
                        </PaperCard>
                    </Grid>

                    <Grid item container spacing={3} xs={6} direction="row" alignContent="flex-start">
                        <Grid item xs={12}>
                            <PaperCard>
                                <Typography variant="body1">
                                    There are two ways to add new devices to this group:
              </Typography>
                                <Typography variant="body2" component="span">
                                    <ol>
                                        <li>Register a new device using the Registration Code.</li>
                                        <li>
                                            Move an existing device to this group from the Devices page.
                  </li>
                                    </ol>
                                </Typography>
                            </PaperCard>
                        </Grid>
                        <Grid item xs={12}>
                            <Accordion defaultExpanded>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                >
                                    <Typography>First Time Use Settings (Advanced)</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <div style={{ width: '100%' }}>
                                        <TextLabel label="First Time Use App" value={firstTimeUseAppTitle} />
                                        <MultiInputTextField initData={firstTimeUseFilePaths} disabled={true} />
                                    </div>
                                </AccordionDetails>
                            </Accordion>
                        </Grid>
                    </Grid>

                    <Grid item xs={12}>
                        <MaterialTable
                            key={"default"}
                            title="Approved Apps"
                            columns={columns}
                            data={approvedApps}
                            icons={{
                                SortArrow: ArrowUpwardIcon
                            }}
                            options={{
                                sorting: true,
                                search: false,
                                pageSize: 25,
                                pageSizeOptions: [5, 10, 25, 100],
                                padding: 'dense',
                                actionsColumnIndex: -1,
                                debounceInterval: 500,
                                toolbarButtonAlignment: 'right',
                                draggable: false,
                                emptyRowsWhenPaging: false,
                            }}
                        />
                    </Grid>
                </Grid>
                <br />
            </DialogContentWithCards>
        </Dialog>
    );
};
